<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Information Technology"
                   :links="[{title:'Home', url:'/'},{title:'Information Technology'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/it/faculty/rokade_p_p.jpg`"
                   alt="Head of Department of Information Technology">
              <h3 class="text-lg font-bold text-gray-800 leading-tight">Prof. Rokade P. P. </h3>
              <h4 class="text-gray-600 leading-tight">Head of the Department</h4>
            </div>
          </div>
          <blockquote class="mt-3 text-gray-600 text-justify font-medium">
            <p>Welcome to Department of Information Technology. The Objective of Information Technology department is
              "To focus on creating versatile IT professionals so that they can apply their Knowledge and skills
              anywhere in the world".The department has both a clear and defined Vision and mission statements aligned
              with that of the College. All the teachers are committed towards every idea of students and attended
              various workshops based on new technologies and published papers in renowned Journals. Department club
              also conducts regular industrial visits to various industries to make students acquaint with recent
              trends in Industry. Department is having healthy and competitive environment. Fully furnished computer
              lab with latest configuration machine with all time internet facility and WI-FI facility to the
              students. This department has qualified and experienced staff. The consistent placement of majority of
              the students of every batch in renowned organizations is the outcome of perseverance, tenacity and
              practices applied at the department and TPO. Prof. Prakash P. Rokade is leading the IT Department in SND
              College OF Engineering from A.Y. 2014-15. As senior teaching professional of SND College of Engineering
              and Research centre, he wishes to impart state of the art world-class quality technical education and
              instill high patterns of discipline to set global standards, making students technologically superior
              and ethically strong.</p>
            <signature name="Prof. Rokade P. P." designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/it/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped />
